import { render, staticRenderFns } from "./PopupMemberUpgrade.vue?vue&type=template&id=3a2256a8&scoped=true&"
import script from "./PopupMemberUpgrade.vue?vue&type=script&lang=js&"
export * from "./PopupMemberUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./PopupMemberUpgrade.vue?vue&type=style&index=0&id=3a2256a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2256a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VCardText,VDialog})
